import produce from "immer";
import isEmpty from 'lodash.isempty';

const initialState = {
  kodyProduktow: [],
  typyZadan: [],
  fetching: false,
  selectedProductKey: {},
  residentName: '',
  login: '',
  permissions: {
    dostepDoAplikacji: true,
    harmonogramRezydentow: true,
    harmonogramAnimacji: true,
    wydruki: true
  }
};

export default function (state = initialState, action) {
  return produce(state, draft => {
    switch(action.type) {
      case 'FETCH_REQUEST':
        draft.fetching = true;
        return;
      case 'INITIALIZE':
        draft.kodyProduktow = action.payload.kodyProduktow;
        draft.typyZadan = action.payload.typyZadan;
        draft.residentName = action.payload.rezydent;
        draft.login = action.payload.login;
        draft.fetching = false;
        draft.permissions = action.payload.dostepy;
        if (isEmpty(draft.selectedProductKey) && action.payload.kodyProduktow) {
          draft.selectedProductKey = { value: action.payload.kodyProduktow[0], label: action.payload.kodyProduktow[0] };
        }
        return;
      case 'SET_PRODUCT_KEY':
        draft.selectedProductKey = action.productKey;
        return;
      default:
        return state;
    }
  })
}
